<template>
  <div class="py-6 py-md-10">
    <v-card
      class="mx-auto overflow-hidden rounded-lg border border-opacity-25"
      max-width="1000"
      color="blue-darken-4"
      elevation="4"
      style="background-image: url(/first-page-bg-pattern-blue-3.webp), linear-gradient(-15deg, #000000 40%, #0403E8 80%); background-position: center"
    >
      <v-row no-gutters align="center">
        <!-- Vertical accent line on the left -->
        <v-col cols="auto" class="d-none d-md-block h-100">
          <div class="bg-green-accent-4" style="width: 6px; height: 100%; min-height: 100px;"></div>
        </v-col>
        <!-- Top accent line for mobile -->
        <v-col cols="12" class="d-md-none">
          <div class="bg-green-accent-4" style="height: 4px; width: 100%;"></div>
        </v-col>

        <v-col class="pa-5 pa-md-8">
          <div class="d-flex flex-column flex-md-row align-md-center justify-space-between">
            <div class="mb-4 mb-md-0">
              <div class="d-flex align-center mb-1">
                <v-icon icon="mdi-shield-crown" color="" opacity="0.4" size="small" class="mr-2"></v-icon>
                <span class="text-caption font-weight-bold text-uppercase opacity-40"  style="letter-spacing: 0.1em;">Enterprise</span>
              </div>
              <div class="text-h3 font-weight-black text-white">
                <span class="font-weight-light">Wiresock Secure Connect</span> <span class="font-weight-black">PRO</span>
              </div>
              <p class="text-subtitle-2 text-md-subtitle-1 text-indigo-lighten-4 mb-0 mt-1" style="max-width: 600px;">
                Centralized control, commercial licensing, and premium support for your corporate environment.
              </p>
            </div>

            <div class="flex-shrink-0">
              <v-btn
                to="/wiresock-secure-connect/pro"
                color="lime-accent-4"
                variant="flat"
                size="large"
                class="text-indigo-darken-4 font-weight-bold px-8"
                rounded="lg"
                append-icon="mdi-arrow-right"
              >
                Learn More
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script setup lang="ts">
/**
 * Minimalist Corporate Stripe variant of the PRO Version Promo Block.
 * Vertically narrow, uses site's primary colors (Indigo/Lime).
 */
</script>

<style scoped>
/* Strictly using Vuetify utility classes for a clean corporate look */
</style>
